export const zhCNTuttiModePlan = {
  taskReview: "计划确认",
  cancel: "取消计划",
  reviewHint: "等待确认",
  reviewHintReplan: "偏好有变",
  materializingTitle: "正在创建任务",
  switchToSelfReview: "切换为自主审核",
  switchingToSelfReview: "正在切换为自主审核",
  selfReviewEnabled: "已启用自主审核",
  selfReviewFailed: "启用自主审核失败",
  materializingHint: "正在将已接受的计划转换为可执行任务",
  errorTitle: "工作流暂不可用",
  expand: "展开工作流",
  collapse: "收起工作流",
  sendAccept: "接受",
  sendRequestChanges: "请求修改",
  replanFeedback:
    "偏好已从效果 {{fromEffect}} / 速度 {{fromSpeed}} 调整为效果 {{toEffect}} / 速度 {{toSpeed}}。请重新规划模型选择和随效果变化的任务验证",
  replanFeedbackSuffix:
    "（当前偏好为效果 {{effect}} / 速度 {{speed}}，请一并重新规划模型选择和任务验证）",
  tasks: "任务",
  priority: "优先级",
  priorityHigh: "高",
  priorityMedium: "中",
  priorityLow: "低",
  agentTarget: "Agent",
  model: "模型",
  permissionMode: "权限模式",
  reasoningEffort: "推理强度",
  parallelizable: "可并行",
  autoAccept: "自动验收",
  assignmentOptionsLoading: "选项加载中...",
  notSpecified: "未指定",
  loadFailed: "无法加载 Tutti mode plan",
  retry: "重试",
  issueOpen: "打开 Issue",
  issueListView: "列表",
  issueBoardView: "看板",
  issueSummary: "{{done}}/{{total}} 已完成 · {{running}} 运行中",
  issueDependencies: "依赖",
  issueAccept: "验收",
  issueRework: "重做",
  issueAcceptPrompt:
    "请在当前 Tutti Mode 计划中验收 {{reference}}，核对任务结果与验证证据，并根据当前 execution 状态继续推进计划",
  issueReworkPrompt:
    "请在当前 Tutti Mode 计划中重做 {{reference}}，先检查当前 execution 与失败或验收证据，保留原任务历史，并根据当前状态创建替代任务或新的后续执行后继续调度",
  issueStageParallel: "阶段 {{index}} · 并行 ×{{count}}",
  issueStageSequential: "阶段 {{index}} · 串行",
  issueStatusNotStarted: "待开始",
  issueStatusRunning: "运行中",
  issueStatusPendingAcceptance: "待验收",
  issueStatusCompleted: "已完成",
  issueStatusFailed: "失败",
  issueStatusCanceled: "已取消",
  issueStripRunning: "{{count}} 个子任务进行中",
  issueStripPending: "{{count}} 待验收",
  issueStripFailed: "{{count}} 失败",
  issueStripDone: "{{done}}/{{total}} 已完成",
  issueCreateFailed:
    "已核准的计划未能创建 Issue：{{message}}。请让 Agent 修订计划"
} as const;
